import { useEffect } from 'react'
import { useLocation } from 'react-router'

export function useMedallia() {
  const location = useLocation()

  useEffect(() => {
    if (
      window.KAMPYLE_ONSITE_SDK
      && typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function'
    ) {
      window.KAMPYLE_ONSITE_SDK.updatePageView()
    }
  }, [location])
}
